(function(){
  var root=document.querySelector('[data-care-slider]'); if(!root) return;
  var tiers=JSON.parse(root.getAttribute('data-tiers')||'[]').sort(function(a,b){return a.max-b.max});
  var range=root.querySelector('[data-care-range]'), dev=root.querySelector('[data-care-device]'), out=root.querySelector('[data-care-price]');
  var loc=root.getAttribute('data-locale')||'de';
  function money(c){return (c/100).toLocaleString(loc,{style:'currency',currency:'EUR'});}
  function update(){
    var v=parseInt(range.value,10); dev.textContent=v.toLocaleString(loc)+' \u20ac';
    var t=null; for(var i=0;i<tiers.length;i++){ if(v<=tiers[i].max){ t=tiers[i]; break; } }
    out.textContent=t?money(t.price):(root.getAttribute('data-unavailable')||'');
    range.style.setProperty('--pct',((v-range.min)/(range.max-range.min)*100)+'%');
  }
  range.addEventListener('input',update); update();
})();
